<template>
  <div id="small_tips">
    <el-dialog
      :title="tipsType ? '' : '再来一单'"
      :visible.sync="tipsVisible"
      width="430"
      :before-close="() => { $emit('tipsSwitch', false, tipsType) }"
    >
      <div class="body_content">
        <svg-icon icon-class="one-more-order" />
        <div class="text_bpx">
          将恢复购物车商品数据，请
          <span class="red-text">
            修改商品数量
          </span>
          或
          <span class="red-text">
            增加其他商品后
          </span>
          重新提交！
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="close_btn" @click="() => { $emit('tipsSwitch', false, tipsType) }">取 消</el-button>
        <el-button class="confirm_btn" type="primary" @click="() => { $emit('tipsSwitch', true, tipsType) }">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    tipsVisible: {
      type: [Boolean]
    },
    tipsType: {
      type: [Number],
      default: null
    }
  },
  data() {
    return {

    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
#small_tips {
    .body_content {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 150px;
        border-bottom: 1px solid #C4CBD7;
        .svg-icon {
            width: 61px;
            height: 61px;
        }
        .text_bpx {
            width: 326px;
            margin-left: 11px;
            font-size: 20px;
            color: #676871;
            .red-text {
                color: #EC212D;
            }
        }
    }
    .dialog-footer {
        .close_btn {
            border: 1px solid #C4CBD7;
            color: #C4CBD7;
        }
    }
}
</style>
<style lang="scss">
#small_tips {
    .el-dialog {
        position: relative;
        top: 45% !important;
        width: 429px;
        height: 252px;
        border-radius: 10px;
    }
    .el-dialog__header {
        height: 40px;
        font-size: 16px;
        padding-left: 23px;
        border-radius: 10px 10px 0 0;
    }
    .el-dialog__body {
        padding: 0;
    }
    .dialog-footer {
        .el-button {
            width: 80px;
            height: 36px;
        }
    }
}
</style>
